<button
  type="button"
  class="accessibility-trigger"
  [nxPopoverTriggerFor]="accessibilityMenu"
  nxPopoverTrigger="click"
  nxPopoverDirection="bottom"
  [nxPopoverCloseable]="false"
  [attr.aria-label]="'Accessibility settings' | transloco"
>
  <svg
    viewBox="0 0 24 24"
    width="20"
    height="20"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M12 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm8 6.5-5.5.5v3.2l1.8 7.3-1.9.5-1.9-6.5h-1l-1.9 6.5-1.9-.5 1.8-7.3V9L4 8.5V6.5l8 .8 8-.8v2Z"
    />
  </svg>
</button>
<nx-popover #accessibilityMenu nxPopoverDirection="bottom">
  <fieldset nxPopoverMainContent class="accessibility-content">
    <legend class="accessibility-title">
      {{ "Accessibility settings" | transloco }}
    </legend>
    <div class="accessibility-controls">
      <div class="font-size-controls">
        <span class="font-size-label">{{ "Text size" | transloco }}</span>
        <button
          type="button"
          class="accessibility-button"
          [disabled]="!settings.canDecreaseFontSize()"
          (click)="settings.decreaseFontSize()"
          [attr.aria-label]="'Decrease text size' | transloco"
        >
          A−
        </button>
        <button
          type="button"
          class="accessibility-button"
          [disabled]="!settings.canIncreaseFontSize()"
          (click)="settings.increaseFontSize()"
          [attr.aria-label]="'Increase text size' | transloco"
        >
          A+
        </button>
      </div>
      <div class="font-size-controls">
        <span class="font-size-label">{{ "Dark mode" | transloco }}</span>
        <button
          type="button"
          class="accessibility-button"
          [attr.aria-pressed]="settings.darkMode()"
          (click)="settings.toggleDarkMode()"
          [attr.aria-label]="'Toggle dark mode' | transloco"
        >
          {{ (settings.darkMode() ? "On" : "Off") | transloco }}
        </button>
      </div>
    </div>
  </fieldset>
</nx-popover>
